import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link, withRouter} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Select from "react-select";
import Edit from '@material-ui/icons/Edit'
import CalendarToday from '@material-ui/icons/CalendarToday'
import {freshdeskTicketDisplay, freshdeskTicketExport, freshdeskTicketUrl, isPendingFreshdeskTicket} from "utils/freshdeskTicket";

class Tickets extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props, model);
		this.props.parent ? this.request = this.props.customerFilter ? 'GET_CUSTOMER_TICKETS' : 'GET_FE_TICKETS' : null;
		this.state.limit = 6;
		this.state.ticketFE = [];
		this.state.ticketFEAll = [];
		this.state.selectedUsers = [];


		if (props.tickets) {
			this.requestData = async (pageSize, page, sorted) => {
				let {tickets} = this.props;

				return {
					rows: tickets.items,
					pages: Math.ceil(tickets.total / pageSize)
				}
			}
		}
	}

	//initial load
	componentDidMount() {
		this.getTicketFE();
	}

	getTicketFE = async () => {
		let model = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_FIELD_ENGINEERS';
		model.limit = 100;
		try {
			model.filter = this.props.customer !== undefined ? {
				'filterUsers': this.state.selectedUsers,
				'customer': this.props.customer
			} : {
				//they might want regions at some point
				// 'filterRegions': this.state.selectedRegions,
				'filterUsers': this.state.selectedUsers,
			}
			this.ticketFE = await model.submit(null, this.read);
			this.ticketFE = Object.keys(this.ticketFE).map((key) => this.ticketFE[key]);
			this.ticketFE = this.ticketFE[3];
			this.setState({
				ticketFE: this.ticketFE
			});
			//sets it initially and when cleared, prevents calling this method in handleUsers from blanking out the select
			//might need to handle differently because if region is selected second itll still show users not available in those regions
			if (this.state.selectedUsers.length === 0) {
				this.state.ticketFEAll = this.ticketFE;
			}
		} catch (error) {
		}
		return this.state.ticketFE;
	}

	updatePage = async () => {
		let table = await this.model.submit(null, "GET_ALL");
		this.setState({
			data: table.items
		})
	}

	//arrow functions make it to where we dont have to bind, so the state is available
	handleUsers = (value) => {
		if (value) {
			let users = [];
			for (let i = 0; i < value.length; i++) {
				users.splice(0, 0, value[i].value);
			}
			this.state.selectedUsers = users;
		} else {
			this.state.selectedUsers = [];
		}
		//refreshing the data after passing filters
		this.getTicketFE();
		this.model.filter = {'filterUsers': this.state.selectedUsers}
		this.updatePage();
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns;
		if (this.props.roles.length === 1 && this.props.roles[0] === 40) {
			columns = [
				{
					Header: "Ticket Number",
					id: "pkey",
					/** @param {Tickets_Object} props.original */
					accessor: obj => obj.pkey
				},
				{
					Header: "Freshdesk Ticket",
					id: "fresh_ticket",
					/** @param {Tickets_Object} props.original */
					accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
					Cell: props => isPendingFreshdeskTicket(props.original.fresh_ticket)
						? <span>{freshdeskTicketDisplay(props.original.fresh_ticket)}</span>
						: <a href={freshdeskTicketUrl(props.original.fresh_ticket)} target={'_blank'}>{props.original.fresh_ticket}</a>
				},
				{
					Header: "Date Created",
					id: 'created',
					/** @param {Tickets_Object} obj */
					accessor: obj => moment(obj.created).local().format('MM/DD/YYYY h:mm A'),
				},
				{
					Header: "Assigned To",
					id: 'field_engineer',
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.assigned ? (obj.field_engineers.name_first + ' ' + obj.field_engineers.name_last) : '',
				},
				{
					Header: "Appointment Start",
					id: 'appointment_start',
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.appointment_start ? moment(obj.appointment_start).local().format('MM/DD/YYYY h:mm A') : '',
				},
				{
					Header: this.props.parent ? "Appointment End" : "Customer",
					id: this.props.parent ? "appointment_end" : 'customers.name',
					/** @param {Tickets_Object} obj */
					accessor: obj => this.props.parent ? (obj.appointment_end ? moment(obj.appointment_end).local().format('MM/DD/YYYY h:mm A') : '') : (obj.customers ? obj.customers.name : ''),
					Cell: (props) => {

						let {original} = props;
						let {customers} = original;

						if (!customers) return null;

						if (this.props.parent) {
							return (
								<p>{props.original.appointment_end ? moment(props.original.appointment_end).local().format('MM/DD/YYYY h:mm A') : ''}</p>);
						} else {
							return (
								<span>
								<Link to={`/customers/${customers.pkey}`}>
									{customers.name}
								</Link>
							</span>
							);
						}
					}

				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								<Link to={"/tickets/" + props.original.pkey}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				},
			];
		} else {
			columns = [
				{
					Header: "Ticket Number",
					id: "pkey",
					/** @param {Tickets_Object} props.original */
					accessor: obj => obj.pkey
				},
				{
					Header: "Freshdesk Ticket",
					id: "fresh_ticket",
					/** @param {Tickets_Object} props.original */
					accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
					Cell: props => isPendingFreshdeskTicket(props.original.fresh_ticket)
						? <span>{freshdeskTicketDisplay(props.original.fresh_ticket)}</span>
						: <a href={freshdeskTicketUrl(props.original.fresh_ticket)} target={'_blank'}>{props.original.fresh_ticket}</a>
				},
				{
					Header: "Date Created",
					id: 'created',
					/** @param {Tickets_Object} obj */
					accessor: obj => moment(obj.created).local().format('MM/DD/YYYY h:mm A'),
				},
				{
					Header: "Assigned To",
					id: 'assigned_to', // Can't use correct column, comes from virtual column
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.assigned ? (obj.field_engineers.name_first + ' ' + obj.field_engineers.name_last) : '',
				},
				{
					Header: "Appointment Start",
					id: 'appointment_start',
					/** @param {Tickets_Object} obj */
					accessor: obj => obj.appointment_start ? moment(obj.appointment_start).local().format('MM/DD/YYYY h:mm A') : '',
				},
				{
					Header: this.props.parent ? "Appointment End" : "Customer",
					id: this.props.parent ? "appointment_end" : 'customers.name',
					/** @param {Tickets_Object} obj */
					accessor: obj => this.props.parent ? (obj.appointment_end ? moment(obj.appointment_end).local().format('MM/DD/YYYY h:mm A') : '') : (obj.customers ? obj.customers.name : ''),
					Cell: (props) => {
						let {original} = props;
						let {customers} = original;

						if (!customers) return null;
						if (this.props.parent) {
							return (
								<p>{props.original.appointment_end ? moment(props.original.appointment_end).local().format('MM/DD/YYYY h:mm A') : ''}</p>);
						} else {
							return (
								<span>
								<Link to={`/customers/${customers.pkey}`}>
									{customers.name}
								</Link>
							</span>
							);
						}
					}
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: props => {
						return (
							<span>
								<Link to={"/tickets/" + props.original.pkey}>
									<Button color="green-meadow" size={"sm"} block={true}>
										<Edit fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 45,
					Cell: (props) => {
						return (
							<span>
								<Link to={"/dispatch/calendar/" + props.original.pkey}>
									<Button color="primary" size={"sm"} block={true} onClick={() => {
										//so the window pops up
										localStorage.setItem('ticketToggled', 'no');
										localStorage.removeItem('users'); //doing this so that ticket correctly pops after creation no matter what
										localStorage.removeItem('regions'); //doing this so that ticket correctly pops after creation no matter what
										localStorage.removeItem('date'); //doing this so that ticket correctly pops after creation no matter what
									}}>
										<CalendarToday fontSize={'small'}/></Button>
								</Link>
							</span>
						);
					}
				},
				// {
				// 	Header: "",
				// 	className: "button-cell",
				// 	filterable: false,
				// 	sortable: false,
				// 	width: 110,
				// 	Cell: (props) => {
				// 		return (
				// 			<span>
				// 				<Button
				// 					color="danger"
				// 					size="sm"
				// 					block={true}
				// 				>
				// 					<i className="fa fa-times"/>
				// 				</Button>
				// 			</span>
				// 		);
				// 	}
				// },
			];
		}
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						{!this.props.noHeader &&
						<div className="d-flex">
							{this.renderSearch('Tickets')}
							{this.props.roles.length !== 1 && this.props.roles[0] !== 40 &&
							<div className={"col-2"}>
								<Select
									placeholder={"Field Engineers"}
									isMulti
									isClearable
									onChange={this.handleUsers}
									options={this.state.ticketFEAll.map(user => {
										return (
											{value: user.pkey, label: user.name_first + " " + user.name_last})
									})}
								/>
							</div>}
							{this.renderHeaderRight("Tickets", columns)}
						</div>}
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						getTdProps={() => ({
							style: {
								height: '35px'
							}
						})}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(Tickets);
